import { useState } from 'react';

const cases = [
  {
    id: 'case01',
    label: 'Case 01',
    title: '空間を支配し、世界観に没入させる香り',
    category: 'エンターテインメント空間の価値向上',
    text: 'ライブやイベントのテーマ・コンセプトに合わせたオリジナルの香りを独自に開発。専用のディフューザーで会場全体を香りで包み込むことで、視覚や聴覚だけでなく「嗅覚」からもアプローチ。来場者の感情を昂らせ、一生の記憶に残る圧倒的な顧客体験（CX）を実現します。',
    image: 'https://public.readdy.ai/ai/img_res/052aa2df39462eded5a34041202a910f.jpg',
  },
  {
    id: 'case02',
    label: 'Case 02',
    title: '心と身体を整え、深い安らぎへ誘う香り',
    category: 'ウェルネス・パーソナルケア',
    text: 'うつ傾向にある方や、睡眠の質に悩む方へ向けた機能的なアプローチ。自律神経を整え、深く穏やかな眠りへと導く香りを開発し、ご自宅の寝室に展開します。日々の疲れをリセットし、パーソナルな空間を「最高の癒しの場」へと変えるお手伝いをします。',
    image: 'https://readdy.ai/api/search-image?query=peaceful%20minimalist%20bedroom%20bathed%20in%20soft%20morning%20light%20through%20sheer%20white%20curtains%2C%20crisp%20white%20linen%20bedding%2C%20warm%20wooden%20accents%2C%20small%20ceramic%20diffuser%20on%20bedside%20table%2C%20calm%20and%20restorative%20atmosphere%2C%20wellness%20lifestyle%20photography&width=600&height=800&seq=exp002&orientation=portrait',
  },
];

export default function Experience() {
  const [activeCase, setActiveCase] = useState('case01');

  return (
    <section id="experience" className="w-full bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end gap-6 md:gap-12 mb-14">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-light text-stone-900 tracking-tight shrink-0">
            EXPERIENCE
          </h2>
          <p className="text-stone-500 text-sm leading-relaxed max-w-xl md:pb-2">
            商業施設やイベントなどの大規模な空間演出から、パーソナルな心身のケアまで。
            AMYMAISONは、多様なシーンに合わせて最適な香りの体験を創出します。
          </p>
        </div>

        {/* Cards */}
        <div className="flex flex-col md:flex-row gap-4">
          {cases.map((c) => {
            const isActive = activeCase === c.id;
            return (
              <div
                key={c.id}
                onClick={() => setActiveCase(c.id)}
                className={`relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
                  isActive ? 'md:flex-[2]' : 'md:flex-[1]'
                } h-[420px] md:h-[560px]`}
              >
                <img
                  src={c.image}
                  alt={c.title}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

                <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-8">
                  <span className="text-white/60 text-xs tracking-widest mb-2">{c.label}</span>
                  <p className="text-white/70 text-xs tracking-wider mb-2">{c.category}</p>
                  <h3 className="text-white text-lg md:text-xl font-light leading-snug mb-3">
                    {c.title}
                  </h3>
                  <p
                    className={`text-white/70 text-xs leading-relaxed transition-all duration-500 overflow-hidden ${
                      isActive ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    {c.text}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
